import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";
import { TimelineEventSchema } from "./timeline";

//Because of circular dependencies I had to move it to its own file
export const ITrackableZodSchema = z.object({
  _id: zExt.objectId(),
  timeline: z.array(TimelineEventSchema),
  trackers: z
    .array(z.object({ _tracker: z.any(), fulfillmentID: z.string() }))
    .optional(),
  trackingTimeline: z.array(z.any()).optional(),
  trackingAnalytics: z
    .object({
      email: z.array(z.any()), //TODO: type this
      page: z.array(
        z.object({
          url: z.string(),
          eventType: z.enum(["ad", "upsell", "promotion", "subscription"]),
          image: z.string().nullish(),
          createdAt: z.date(),
        }),
      ),
    })
    .optional(),
  trackingTextsSent: z
    .array(z.object({ sid: z.string(), mms: z.boolean(), sentAt: z.date() }))
    .nullish(),
  trackingEmailsSent: z
    .array(
      z.object({
        emailId: z.string(),
        status: z.string().optional(),
        sentAt: z.date(),
        s3URL: z.string().nullish(),
        trigger: z.string().optional(),
        attachmentInfo: z
          .object({
            hasAttachments: z.boolean().optional(),
            attachmentCount: z.number().optional(),
            attachmentNames: z.array(z.string()).optional(),
          })
          .optional(),
      }),
    )
    .optional(),
  trackingWebhooksSent: z
    .array(
      z.object({
        destinationUrl: z.string(),
        sentAt: z.date(),
        automationStepId: z.string(),
        statusCode: z.number().optional(),
        success: z.boolean(),
        trigger: z.string(),
      }),
    )
    .nullish(),
  trackingBillingStatus: z.enum(["billed", "free"]).nullish(),
  discount: z
    .object({
      id: z.string().nullish(),
      description: z.string().nullish(),
      code: z.string().nullish(),
      expirationDateTime: z.string().nullish(),
    })
    .optional(),
});
